const LOGO_URL =
  "https://firebasestorage.googleapis.com/v0/b/aya-web-822dd.firebasestorage.app/o/Logo%2Flgo%204.png?alt=media&token=d9ff5f3b-3842-4d94-a9ce-606ff04bc758";

export default function Logo({ size = 28, ariaLabel = "Aya Technologies" }) {
  return (
    <img
      src={LOGO_URL}
      alt={ariaLabel}
      width={size}
      height={size}
      draggable={false}
      style={{ display: "block" }}
    />
  );
}
